import Loading from '@/components/general/Loading';
import StaffMemberTimeOffComponent from './StaffMemberTimeOff.component';
import { useStaffMemberInfoContext } from '../StaffMemberInfo/StaffMemberInfo.context';

const StaffMemberTimeOff = (): JSX.Element => {
  const { staffMember } = useStaffMemberInfoContext();

  if (!staffMember) {
    return (
      <div className="tw-flex tw-items-center">
        <Loading fullPage />
      </div>
    );
  }

  return <StaffMemberTimeOffComponent staffMember={staffMember} />;
};

export default StaffMemberTimeOff;
